<mat-toolbar class="sidenav-header" [ngClass]="isExpanded ? 'justify-content-end isExpanded px-0': ''">
  <button mat-icon-button (click)="toggleSidenav()">
    <mat-icon>{{ isExpanded ? 'menu_open' : 'menu' }}</mat-icon>
  </button>
</mat-toolbar>

<!-- Normal Mode -->
<ng-container *ngIf="!isCompactMode; else compactMenu">
  <div class="menu-scroll" #scrollContainer>
    <mat-nav-list class="mat-sidenav-list">
      <a class="menu-item-link" mat-list-item [routerLinkActive]="['sidenav-active-links']"
        *ngFor="let item of menuItems" [routerLink]="item.route" (click)="handleSidenavCollapse($event.currentTarget)"
        matTooltip="{{!isExpanded ? (item.name | translate) : ''}}" matTooltipPosition="right"
        matTooltipClass="custom-tooltip">
        <mat-icon>{{ item.icon }}</mat-icon>
        @if (isExpanded) {
        <span class="fs-7 nav-text">{{ item.name | translate }}</span>
        }
      </a>
    </mat-nav-list>
  </div>
  <div class="mob-download">
    <span class="page-hed-img d-block">
      <a href="https://play.google.com/store/apps/details?id=com.unipanel&pli=1" target="_blank">
        <img src="../../../../../assets/images/playstore.png" alt="android">
      </a>
    </span>
    <span class="page-hed-img d-block">
      <a href="https://apps.apple.com/us/app/opinion-edge/id6446476343" target="_blank">
        <img src="../../../../../assets/images/App-Store.png" class="ios-ico" alt="ios">
      </a>
    </span>
  </div>
</ng-container>

<!-- Compact Mode (Height < 500) -->
<ng-template #compactMenu>
  <mat-nav-list class="mat-sidenav-list menu-scroll">
    <!-- First 3 items -->
    <a class="menu-item-link" mat-list-item *ngFor="let item of menuItems.slice(0, 4)" [routerLink]="item.route"
      (click)="handleSidenavCollapse()" [routerLinkActive]="['sidenav-active-links']" matTooltipPosition="right"
      matTooltip="{{!isExpanded ? (item.name | translate) : ''}}">
      <mat-icon>{{ item.icon }}</mat-icon>
      @if (isExpanded) {
      <span class="fs-7 nav-text">{{ item.name | translate }}</span>
      }
    </a>


    <a class="menu-item-link" [matMenuTriggerFor]="moreMenu" mat-list-item matTooltip="{{ 'moreLinks' | translate }}"
      matTooltipPosition="right" matTooltipClass="custom-tooltip">
      <mat-icon>more_vert</mat-icon>
      @if (isExpanded) {
      <span class="fs-7 nav-text">{{ 'moreLinks' | translate }}</span>
      }
    </a>
  </mat-nav-list>

  <!-- More Menu -->
  <mat-menu class="custom-morelinks" #moreMenu="matMenu" xPosition="after" yPosition="below">
    <a class="menu-item-link text-start" mat-list-item [routerLinkActive]="['sidenav-active-links']"
      *ngFor="let item of menuItems.slice(4)" [routerLink]="item.route" (click)="handleSidenavCollapse()">
      <mat-icon>{{ item.icon }}</mat-icon>
      <span class="fs-7 nav-text">{{ item.name | translate }}</span>
    </a>
  </mat-menu>
</ng-template>